import HistoryIcon from '@material-ui/icons/History';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { useHistoryDropdownStyles } from './HistoryDropdown.styles';

export type HistoryDropdownItem = {
  id: string | number;
  label: string;
  italic?: boolean;
};

type HistoryDropdownProps = {
  items: HistoryDropdownItem[];
  activeId?: string | number;
  onSelect: (id: string | number) => void;
  label?: string;
  className?: string;
};

const HistoryDropdown = ({
  items,
  activeId,
  onSelect,
  label = 'Historique',
  className,
}: HistoryDropdownProps) => {
  const classes = useHistoryDropdownStyles();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!items.length) {
    return null;
  }

  const handleSelect = (id: string | number) => {
    onSelect(id);
    setOpen(false);
  };

  return (
    <div className={clsx(classes.historyWrapper, className)} ref={wrapperRef}>
      <button
        type="button"
        className={classes.historyButton}
        aria-expanded={open}
        onClick={() => setOpen(prev => !prev)}>
        <HistoryIcon className={classes.historyIcon} />
        {label}
        <KeyboardArrowDownIcon
          className={clsx(classes.historyDropdownIcon, open && classes.historyDropdownIconOpen)}
        />
      </button>

      {open && (
        <ul className={classes.historyPanel}>
          {items.map(item => (
            <li key={item.id}>
              <button
                type="button"
                className={clsx(
                  classes.historyItem,
                  item.italic && classes.historyItemItalic,
                  activeId === item.id && classes.historyItemActive,
                )}
                onClick={() => handleSelect(item.id)}>
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default HistoryDropdown;
